import { render, staticRenderFns } from "./SideBarComponent.vue?vue&type=template&id=425f7310"
import script from "./SideBarComponent.vue?vue&type=script&lang=js"
export * from "./SideBarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports